import React, { Component } from "react"
import PropTypes from "prop-types"

import { bindActionCreators } from "redux"
import { connect } from "react-redux"

import { LinkContainer } from "react-router-bootstrap"
import {
  Grid, PageHeader, Table, Button, Glyphicon,
  //FormGroup, ControlLabel, FormControl
} from "react-bootstrap"

import { Map } from "immutable"
import numeral from "numeral"

import * as actionCreators from "../actions"
import { ButtonAdd, getRecords } from "./Common"

class ProductReturns extends Component {
  static propTypes = {
    productReturns: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
  }

  state = {}

  handleDelete = e => {
    e.preventDefault()
    
    const { id } = e.target
    if (window.confirm("Are you sure you want to delete this item?")) {
      this.props.actions.deleteReturn(id)
    }
  }

  render() {
    return (
      <Grid>
        <PageHeader>
          Daftar Retur
          <span className="pull-right"><ButtonAdd to="/return/new" /></span>
        </PageHeader>

        <Table responsive fill striped>
          <thead>
            <tr>
              {/* <th className="text-center">&nbsp;</th> */}
              <th className="text-center">No. Order</th>
              <th className="text-center">Barang</th>
              <th className="text-center">Dealer</th>
              <th className="text-center">Nama Customer</th>
              <th className="text-center">Alamat Customer</th>
              <th className="text-center">Biaya</th>
              <th className="text-center">Keterangan</th>
              <th className="text-center">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            { getRecords(this.props.productReturns).map(o => (
              <tr key={o.get("uuid")}>
                <td>
                  {o.get("orderNo")}
                  <Button className="pull-right" bsSize="xsmall" bsStyle="danger" id={o.get("uuid")} onClick={this.handleDelete}>
                    <Glyphicon glyph="trash" id={o.get("uuid")} />
                  </Button> 
                </td>
                <td className="text-center">{o.get("productName")}</td>
                <td className="text-center">{this.props.dealers.getIn([o.get("dealerUuid"), "dealerName"])}</td>
                <td className="text-center">{o.get("customerName")}</td>
                <td>
                  {
                    o.get("customerAddress") && o.get("customerAddress").length > 30 ?
                    o.get("customerAddress").substr(0, 27) + "..." :
                    o.get("customerAddress") 
                  }
                </td>
                <td className="text-right">{numeral(o.get("returnCost")).format("0,0")}</td>
                <td>
                  {
                    o.get("notes") && o.get("notes").length > 30 ?
                    o.get("notes").substr(0, 27) + "..." :
                    o.get("notes")
                  }
                </td>
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  <LinkContainer to={`/return/${o.get("uuid")}`}>
                    <Button bsSize="xsmall">Detail</Button>
                  </LinkContainer>
                </td>
              </tr>
            )) }
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="100">&nbsp;</td>
            </tr>
          </tfoot>
        </Table>
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  productReturns: state.get("productReturns") || Map(),
  dealers: state.get("dealers") || Map()
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductReturns)



// WEBPACK FOOTER //
// ./src/components/ProductReturns.js